import * as React from 'react';
import '../Home/Buttons.css'
import ButtonsCustomNClientesLicencasExpiradas from "./CustomButtonsAdmin/BNClientesLicencasExpiradas"
import ButtonsCustomNclients from './CustomButtonsAdmin/BNclients';
import ButtonsCustomNLicencasExpirando from './CustomButtonsAdmin/BNLicencasExpirando';
import CustomizedDemoLicense from './CustomButtonsAdmin/BnDemonstracao'
import './ButtonsAdmin.css'

function ButtonsAdmin() {
    return (
        <div className="containerButtonAdmin">
            <div className="containerNclientsButtons">
                <ButtonsCustomNclients></ButtonsCustomNclients>
            </div>
            <div className="containerNLicencasExpirando" >
                <ButtonsCustomNLicencasExpirando></ButtonsCustomNLicencasExpirando>
            </div>
            <div className="containerNclientesLicenca" >
                <ButtonsCustomNClientesLicencasExpiradas></ButtonsCustomNClientesLicencasExpiradas>
            </div >
            <div className="containerNclientesLicenca" >
                <CustomizedDemoLicense/>
            </div >
        </div>
    );
}
export default ButtonsAdmin